/* eslint-disable max-lines */
import React, { useContext, useState } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { getTime, getFullDate, getFullDateTime } from '../../utils/dateTimeUtil';
import { PropTypes } from 'prop-types';
import EDIT_IMG from '../../assets/images/edit.svg';
import TRASH_IMG from '../../assets/images/trash.svg';
import { AlertDialog } from '../UI';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteAppointment,
    setSelectedAppointment,
    resetAppointmentEditRelatedStates
} from '../../redux/Appointment/AppointmentAction';
import { getAdmissionDetail } from '../../redux/Appointment/AppointmentAction';
import { useHistory, useParams } from 'react-router';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Appointment/AppointmentType';
import useCheckAccess from '../../hooks/useCheckAccess';
const styles = makeStyles({
    appointmentItem: ({ noAccess }) => ({
        width: '100%',
        display: 'flex',
        borderBottom: '0.7px solid #efefef',
        padding: '0 15.5px',
        overflowY: 'visible',
        borderRadius: '8px',
        '&:nth-child(even)': {
            backgroundColor: '#e8ecf2'
        },
        '& > div': {
            display: 'flex',
            justifyContent: 'center',
            flexFlow: 'column'
        },
        '&:last-child': {
            borderBottom: 'none'
        },
        '&:hover': {
            backgroundColor: !noAccess && '#c0c0c0',
            '& .options': {
                visibility: !noAccess && 'visible'
            }
        },
        '& .options': {
            width: '10%',
            flexFlow: 'row !important',
            visibility: 'hidden',
            '& > div': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
            '& img ': {
                width: '20px',
                height: '20px',
                margin: '12px',
                cursor: 'pointer',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
    }),
    clinicName: {
        minWidth: '125px',
        width: '17%'
    },
    date: {
        minWidth: '85px',
        width: '7%',
        padding: '15px 0 13px'
    },
    time: {
        minWidth: '85px',
        width: '6%',
        padding: '15px 0 13px',
        margin: '0 25px'
    },
    phone: {
        minWidth: '115px',
        width: '17%'
    },
    complaint: {
        minWidth: '220px',
        width: '25%'
    },
    state: {
        // maxWidth: '110px',
        flex: '1 1 120px',
        width: '100%',
        '& > span': {
            borderRadius: '16px',
            padding: '3px 10px',
            textAlign: 'center'
        }
    },
    header: {
        color: '#767676',
        fontWeight: '500',
        borderBottom: '1px solid #efefef',
        display: 'flex',
        alignItems: 'center',
        padding: '0 15.5px',
        position: 'sticky',
        top: '-40px',
        background: '#fff',
        zIndex: '99'
    },
    textarea: {
        fontFamily: 'inherit',
        border: '1px solid white',
        '&::-webkit-resizer': {
            display: 'none'
        },
        '&:focus': {
            border: 'solid 1px rgba(27, 144, 250, 0.7)',
            borderRadius: '4px'
        }
    },
    complaintInput: {
        width: '200px',
        border: '1px solid white'
    },
    phoneInput: {
        width: '100px'
    },
    loader: {
        width: '17px !important',
        height: '17px !important'
    }
});
export const AppointmentItem = ({ appointment }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const { notEditDemographic } = useCheckAccess();
    const classes = styles({ noAccess: notEditDemographic });
    const params = useParams();
    const history = useHistory();
    const [alert, setAlert] = useState({
        alertText: messages.alerts.deleteAppointment,
        opened: false
    });
    const loadingSelector = createLoadingSelector(type.SET_SELECTED_ADMISSION.REQUEST);
    const isLoading = useSelector(loadingSelector);

    const renderAppointmentState = (state) => {
        switch (state) {
            case 'exited':
                return (
                    <span style={{ color: '#545e66', backgroundColor: '#edeeef' }}>
                        {messages.appointmentStatus.visited}
                    </span>
                );
            case 'entered':
                return (
                    <span style={{ color: '#2dcc70', backgroundColor: '#e9fbef' }}>
                        {messages.appointmentStatus.entered}
                    </span>
                );
            case 'admitted':
                return (
                    <span style={{ color: '#faa550', backgroundColor: '#fff6ed' }}>
                        {messages.appointmentStatus.admitted}
                    </span>
                );
            default:
                return (
                    <span style={{ color: '#1b90fa', backgroundColor: '#edf5ff' }}>
                        {messages.appointmentStatus.appointed}
                    </span>
                );
        }
    };

    const handleDeleteAlert = (appointment) => {
        // const firstConst = ' آیا از حذف نوبت ';
        const patient = appointment.patient.first_name + ' ' + appointment.patient.last_name;
        // const secondConst = ' در  ';
        const date = getFullDateTime(appointment.appointed);
        // const lastConst = ' اطمینان دارید؟ ';
        setAlert({
            alertText: getConfirmMessage(date, patient),
            opened: true
        });
    };
    const getConfirmMessage = (date, patient) => {
        if (lang === 'fa') {
            return (
                messages.alerts.askDeleteAppointment +
                ' ' +
                patient +
                ' ' +
                messages.alerts.at +
                ' ' +
                date +
                ' ' +
                messages.alerts.areYouSure
            );
        } else {
            return (
                messages.alerts.askDeleteAppointment +
                ' ' +
                patient +
                ' ' +
                messages.alerts.at +
                ' ' +
                date +
                ' ?'
            );
        }
    };
    const dispatch = useDispatch();
    const handleDeleteAppointment = async () => {
        await dispatch(deleteAppointment(appointment.id));
        setAlert({
            alertText: messages.alerts.deleteAppointment,
            opened: false
        });
    };

    const selectAppointment = async () => {
        await dispatch(resetAppointmentEditRelatedStates(null));
        if (appointment.admitted) {
            await dispatch(getAdmissionDetail(appointment.admission_id));
        }
        await dispatch(setSelectedAppointment(appointment));
        history.push(`/${params.clinicId}/patient/${params.id}/appointments/new`);
    };
    if (!appointment) {
        return null;
    }
    return (
        <div className={classes.appointmentItem}>
            <div className={classes.clinicName}>{appointment.clinic?.name}</div>
            <div className={classes.date}>
                <div>{getFullDate(appointment.appointed)}</div>
            </div>
            <div className={classes.time}>
                <div>{getTime(appointment.appointed)}</div>
            </div>
            <div className={classes.phone}>
                <div>{appointment?.phone_number}</div>
            </div>
            <div className={classes.complaint}>
                <div>{appointment.initial_complaint}</div>
            </div>
            <div className={classes.state}>{renderAppointmentState(appointment.state)}</div>
            <div className="options">
                <div>
                    {isLoading ? (
                        <CircularProgress className={classes.loader} width={10} />
                    ) : (
                        <img onClick={selectAppointment} src={EDIT_IMG} width={12} alt="edit" />
                    )}
                </div>
                <div>
                    <img
                        src={TRASH_IMG}
                        width={12}
                        alt="remove"
                        onClick={() => handleDeleteAlert(appointment)}
                    />
                </div>
            </div>
            <AlertDialog
                open={alert.opened}
                alertText={alert.alertText}
                cancelText={messages.no}
                confirmText={messages.yes}
                handleAction={handleDeleteAppointment}
                handleClose={() => setAlert({ opened: false })}
            />
        </div>
    );
};
AppointmentItem.propTypes = {
    appointment: PropTypes.object
};
export const AppointmentHeader = () => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    return (
        <div className={classes.header}>
            <div className={classes.clinicName}>{messages.clinic}</div>
            <div className={classes.date}>{messages.date}</div>
            <div className={classes.time}>{messages.hour}</div>
            <div className={classes.phone}>{messages.phoneNo} </div>
            <div className={classes.complaint}>{messages.reasonOfReferral} </div>
            <div className={classes.state}>{messages.status}</div>
            <div className={classes.options}></div>
        </div>
    );
};
